export const EVENTS_MEMBERS = {
    FETCH_MEMBERS_AGAIN: "MEMBERS.FETCH_MEMBERS_AGAIN"
};
